import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import CardInfo from '../../../components/CardInfo/CardInfo'
import EditAction from '../../ProfilePage/components/EditAction'
import InfoLine from '../../../components/CardInfo/components/InfoLine'
import InputText from '../../../components/InputText/InputText'
import { useFormik } from 'formik'
import {
    getInitialValues,
    validationSchema,
} from '../../../forms/PurchaseOrderForm'
import useScreen from '../../../hooks/useScreen'

const PurchaseOrder = ({ handleSubmit, poNumber, isEditable }) => {
    const [isEnabledNP, setIsEnabledNP] = useState(false)
    const [firstInputTouch, setFirstInputTouch] = useState(true)
    const [showExtraInfo, setShowExtraInfo] = useState(false)
    const { isMobile } = useScreen()

    useEffect(() => {
        // to restart the initial value if the user cancel the edit
        if (!isEnabledNP) {
            resetForm()
            setFieldValue('poNumber', '')
            setShowExtraInfo(false)
        }
    }, [isEnabledNP])

    const {
        getFieldProps,
        isValid,
        handleSubmit: onSubmitForm,
        setFieldValue,
        errors,
        touched,
        values,
        resetForm,
    } = useFormik({
        validationSchema,
        initialValues: getInitialValues(),
        onSubmit: formValues => {
            handleSubmit && handleSubmit(formValues)
        },
    })

    useEffect(() => {
        if (touched['poNumber'] && isEnabledNP) {
            setShowExtraInfo(!isValid)
        }
    }, [isValid, touched])

    useEffect(() => {
        const initialFormValues = getInitialValues()
        if (
            firstInputTouch &&
            values?.poNumber !== initialFormValues?.poNumber
        ) {
            setFirstInputTouch(false)
            touched['poNumber'] = true
        }
    }, [values, isValid])

    const renderForm = () => {
        return (
            <div className="w-full h-auto flex flex-col items-start justify-start py-2">
                <InfoLine
                    label="PO Number"
                    extraSpace={true}
                    prompText="Once PO # has been saved, field is no longer editable"
                    value={
                        isEditable ? (
                            <InputText
                                {...getFieldProps('poNumber')}
                                error={errors['poNumber']}
                                placeholder="Add Purchase Order number"
                                isRequired
                                disabled={!isEnabledNP}
                                showExtraInfo={showExtraInfo}
                            />
                        ) : (
                            poNumber
                        )
                    }
                />
            </div>
        )
    }

    return (
        <form onSubmit={onSubmitForm} className="w-full">
            <CardInfo
                isOverflowVisible
                title="Purchase Order"
                content={renderForm()}
                titleClass={isMobile && isEnabledNP && 'w-full'}
                headerActions={[
                    isEditable && (
                        <EditAction
                            setEnabled={setIsEnabledNP}
                            isValid={isValid && isEnabledNP}
                            key="editButton"
                        />
                    ),
                ]}
            />
        </form>
    )
}

PurchaseOrder.propTypes = {
    poNumber: PropTypes.string,
    handleSubmit: PropTypes.func,
    isEditable: PropTypes.bool,
}

export default PurchaseOrder
